import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import Blog from "./sections/Blog";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <Header />
      <Blog />
      <Footer />
    </div>;
}